import { render, staticRenderFns } from "./Cover.vue?vue&type=template&id=7572cc56&scoped=true&"
import script from "./Cover.vue?vue&type=script&lang=js&"
export * from "./Cover.vue?vue&type=script&lang=js&"
import style0 from "./Cover.vue?vue&type=style&index=0&id=7572cc56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572cc56",
  null
  
)

export default component.exports